<template>
    <div>
        <CommonPopupFrame :changeBottom="0" :changeHeight="60" :isOpen="isOpen" :closeCompleteAction="closeCompleteAction">
            <div style="width: 36px; height: 5px; background-color: #d9d9d9; margin: 0 auto; border-radius: 5px; margin-top: 5px"></div>
            <div @click="closeCompleteAction" style="padding-left: 12px; margin-top: 6px; font-weight: 700; color: #808080; height: 30px; width: 50px;">닫기</div>
            <div @touchmove.stop="() => { }" style="margin-top: 31px; flex: 1; overflow-y: scroll; padding: 0 12px; padding-bottom: 20px;">
                <div style="text-align: center;">
                    <div style="font-weight: 700; font-size: 32px; line-height: 46px;">자기소개 편집</div>
                    <div style="margin-top: 15px; font-weight: 500; line-height: 24px;">자기소개를 변경할 수 있습니다.</div>
                    <div style="margin-top: 40px; position: relative">
                        <input placeholder="50자 이내로 소개해주세요" ref="intro" style="width: 100%; background-color: #f5f5f5; outline: none; border: none; border-radius: 12px; padding: 12px; padding-right: 40px;" v-model="intro" type="text">
                        <img @click="deleteAll" style="width: 20px; position: absolute; right: 12px; top: 50%; transform: translateY(-50%);" :src="require('@/assets/images/mypage/circle_x.png')" alt="">
                    </div>
                </div>
            </div>
            <div style="height: 90px; padding: 0 12px;">
                <div @click="save" v-if="intro !== ''" class="save_btn_active">저장하기</div>
                <div v-else class="save_btn_unactive">저장하기</div>
            </div>
        </CommonPopupFrame>
    </div>
</template>

<script>
import CommonPopupFrame from '@/components/modal/my/CommonPopupFrame'
import ResponseCode from '../../ResponseCode'
// import { PROFILE_BOX_LIST } from '@/Constants'

export default {
    name: 'SettingProfileIntro',
    components: { CommonPopupFrame },
    props: {
        isOpen: {
            type: Boolean,
            default: false,
        },
        closeCompleteAction: {
            type: Function,
            default: () => { },
        },
    },
    data() {
        return {
            intro: ''
        }
    },
    methods: {
        deleteAll() {
            this.intro = ''
            this.$nextTick(() => {
                this.$refs.intro.focus()
            })
        },
        async save() {
            this.$GlobalStore.showProgress()

            const formData = new FormData()
            formData.append('introduce', this.intro)

            const res = await this.$Axios.post('/api/profile/save', formData, { headers: { 'Content-Type': 'multipart/form-data' } });

            if (res.data.code === ResponseCode.SUCCESS) {
                this.intro = ''
                this.$GlobalStore.hideProgress()
                this.closeCompleteAction(true)
            }
        }
    },
    watch: {
        isOpen(newVal) {
            if (!newVal) {
                this.intro = ''
            }
        }
    },
    created() {
        this.save = this.$Once(this.save)
    }
}
</script>

<style scoped>
.common_box {
    padding: 10px;
    border-radius: 12px;
    background-color: #f5f5f5;
    margin-top: 40px;
}

.save_btn_active {
    height: 48px;
    line-height: 48px;
    border-radius: 12px;
    background-color: #210f03;
    text-align: center;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    margin-top: 12px;
}

.save_btn_unactive {
    height: 48px;
    line-height: 48px;
    border-radius: 12px;
    background-color: #f5f5f5;
    text-align: center;
    color: #d9d9d9;
    font-size: 14px;
    font-weight: 500;
    margin-top: 12px;
}

.active {
    background-color: #210f03;
    color: #fff;
}

input::placeholder {
    font-weight: 500;
    font-size: 14px;
    color: #bbbbbb;
}
</style>